module.exports = {
  overrideHost: true,
  host: 'https://localhost.surfandscan.com:8000',
  VERSION: '2.103.08',
  language: 'de',
  isCloud: false,
  isDev: false,
  isProd: true
}



// WEBPACK FOOTER //
// ./src/config.js